/**
 * Compatibility layer for the API response headers.
 */
export type APIResponseObjectHeaders = Record<string, string>;
export type APIResponseHeaders = APIResponseObjectHeaders | Headers;
export type APIResponse = { headers: APIResponseHeaders };

/**
 * Get a list of channels to subscribe to from an APIresponse.
 */
export function getSubscriptionChannelsForHeaders(headers: APIResponseHeaders): string[] {
    return splitChannelIds(getHeader(headers, 'x-gitbook-subscription-channels') || '');
}

/**
 * Get a list of channels mutated
 */
export function getMutatedChannelsForHeaders(headers: APIResponseHeaders): string[] {
    return splitChannelIds(getHeader(headers, 'x-gitbook-mutations') || '');
}

/**
 * Get the execution ID for a response.
 */
export function getExecutionIdForHeaders(headers: APIResponseHeaders): string | null {
    return getHeader(headers, 'x-gitbook-execution-id') || null;
}

/**
 * Parse an event source message.
 */
export function parseEventSourceMessage(data: unknown): { executionId: string } | null {
    if (typeof data !== 'string') {
        return null;
    }

    try {
        const parsed = JSON.parse(data) as unknown;
        if (
            parsed &&
            typeof parsed === 'object' &&
            'data' in parsed &&
            typeof parsed.data === 'string'
        ) {
            return { executionId: parsed.data };
        }
        return null;
    } catch (_err) {
        return null;
    }
}

/**
 * Split a raw string of channel IDs into an array.
 */
function splitChannelIds(raw: string): string[] {
    return raw
        .split(',')
        .map((channel) => channel.trim())
        .filter(Boolean);
}

/**
 * Get a header from a API response headers.
 */
function getHeader(headers: APIResponseHeaders, name: string): string | null {
    if (headers instanceof Headers) {
        return headers.get(name) || null;
    }

    return headers[name] || null;
}
